import React from "react"
import { componentStyles, useTheme } from "@mallardbay/lib-react-components"

import ResponsiveBlock from "~components/shared/responsive-block"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
} from "~graphql/generated/graphql"
import BackButton from "~components/shared/back-button"
import ListingTitleActionButtons from "~components/pages/listing/listing-title/listing-title-action-buttons"
import ListingTitleInfoBox from "~components/pages/listing/listing-title/listing-title-info-box"
import ListingTitleHeader from "~components/pages/listing/listing-title/listing-title-header"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly listing: PublicListingFieldsFragment | ListingFieldsFragment
    readonly shouldHideButtons?: boolean
    readonly noPadding?: boolean
    readonly isOwner?: boolean
}

export default function ListingTitle({
    shouldHideButtons,
    noPadding,
    listing,
    isOwner,
}: Props) {
    const { id, title } = listing
    const styles = useStyles({ noPadding })
    const { isLargerThanTablet } = useTabletMediaQueries()

    return (
        <ResponsiveBlock noPadding={noPadding}>
            <Box style={styles.root}>
                {isLargerThanTablet && !shouldHideButtons && <BackButton />}
                <ListingTitleHeader
                    title={title}
                    isOwner={isOwner}
                    listingId={id}
                />
                <Box style={styles.info}>
                    <ListingTitleInfoBox listing={listing} />
                    <ListingTitleActionButtons
                        listingId={id}
                        shouldHideButtons={shouldHideButtons}
                    />
                </Box>
            </Box>
        </ResponsiveBlock>
    )
}

function useStyles({ noPadding }: { noPadding?: boolean }) {
    const { colors } = useTheme()

    const paddingTopBase = noPadding ? 0 : "24px"
    const paddingTopMd = noPadding ? 0 : "32px"
    const paddingBottomBase = noPadding ? 0 : "4px"
    const paddingBottomMd = noPadding ? 0 : "16px"

    return componentStyles({
        root: {
            color: colors.contentPrimary,
            paddingTop: {
                base: paddingTopBase,
                md: paddingTopMd,
            },
            paddingRight: 0,
            paddingBottom: {
                base: paddingBottomBase,
                md: paddingBottomMd,
            },
            paddingLeft: 0,
        },
        info: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: { base: "0", md: "4px" },
        },
    })
}
